import React, { useState } from "react";

function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is web development and why is it important for my business?",
      answer: "Web development involves creating and maintaining websites that help businesses establish an online presence. A professionally developed website improves brand visibility, attracts customers, and increases conversions.",
    },
    {
      question: "How long does it take to develop a website?",
      answer: "The timeline depends on the complexity of the project. A basic website can take 7–15 days, while a custom or ecommerce website may take 3–6 weeks or more.",
    },
    {
      question: "Do you provide SEO-friendly web development services?",
      answer: "Yes, we build websites with SEO best practices, including fast loading speed, mobile responsiveness, clean code structure, and optimized content to help improve search engine rankings.",
    },
    {
      question: "Can you redesign my existing website?",
      answer: "Absolutely! We offer website redesign services to improve design, performance, and user experience, ensuring your site meets modern standards and delivers better results.",
    },
    {
      question: "Do you provide support and maintenance after website launch?",
      answer: "Yes, we offer ongoing maintenance and support services, including updates, security checks, and performance optimization to keep your website running smoothly.",
    },

  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="k-faq-section">
      <div className="k-faq-container">
        <h2 className="k-faq-heading">Frequently Asked Questions</h2>

        {faqData.map((item, index) => (
          <div
            key={index}
            className={
              activeIndex === index ? "k-faq-box active" : "k-faq-box"
            }
          >
            <div
              className="k-faq-question"
              onClick={() => toggleFAQ(index)}
            >
              <span className="k-faq-title">{item.question}</span>
              <span className="k-faq-arrow">
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </div>

            <div className="k-faq-answer">
              <p className="k-faq-text">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default FAQ;